// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { CSSProperties } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { ControlLabel, FormControl } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import ActivityFormFieldWrapper from './ActivityFormFieldWrapper';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { StyledMobileBoxItemRow } from '../../utils/Styles/DataBoxStyles';

type Props = {
  label: string;
  name: string;
  value: string | number | undefined;
  onMetaFieldsChange(values: unknown | unknown[]): void;
  isMobileView?: boolean;
  isMobileEditMode?: boolean;
  labelStyle?: CSSProperties;
  disabled?: boolean;
};

const ActivityFormField = ({
  label,
  name,
  value,
  onMetaFieldsChange,
  isMobileView,
  isMobileEditMode,
  labelStyle,
  disabled,
}: Props) => {
  const onChange = e => {
    onMetaFieldsChange([{ name, value: e.target.value }]);
  };

  if (isMobileView) {
    return (
      <StyledMobileBoxItemRow
        maxWidth='100%'
        isEditableRow
        isMobileEditMode={isMobileEditMode}
      >
        <span className='field-label'>{label}:</span>
        {isMobileEditMode ? (
          <textarea disabled={disabled} onChange={onChange} value={value} />
        ) : (
          <span> {value}</span>
        )}
      </StyledMobileBoxItemRow>
    );
  }

  return (
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    <ActivityFormFieldWrapper label={label}>
      <ControlLabel style={labelStyle}>{label}:</ControlLabel>
      <FormControl
        disabled={disabled}
        componentClass='textarea'
        onChange={onChange}
        value={value ?? ''}
      />
    </ActivityFormFieldWrapper>
  );
};

export default ActivityFormField;
